export class PaymentRequest {
  public productType?: string;
  public currency?: string;
  public referenceNumber?: string;
  public source?: string;
  public amount?: number;
  public contractCode?: string;
  public applicationName?: string;
  public productName?: string;
  public transactionId?: string;
  constructor(initial: any) {
    const now = new Date().toISOString().replaceAll('-','').replaceAll('T','').replaceAll(':','').replaceAll('.','').replaceAll('Z','');
    this.currency = 'SGD';
    this.source = 'LIFE_DIRECT';
    this.productType = 'H';
    this.contractCode = 'CQG';
    Object.assign(this, initial);
    this.referenceNumber = `QB${this.contractCode}${now}`;
  }
}